/**
 * @module Utilities/History
 * @desc History helper funtions
 *
 */
import config from 'config';
import { createBrowserHistory, History } from 'history';

export type { LocationDescriptorObject } from 'history';

export const history = createBrowserHistory({
  basename: config.app.basename,
});
